import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.is_admin) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const inputCls =
    "w-full rounded-none border-b border-white/25 bg-transparent py-4 text-white placeholder:text-white/40 focus:border-brand-gold focus:outline-none transition-colors";

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-green px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <p className="font-serif text-4xl font-light text-white">
          Lauréate <span className="text-brand-gold">Commodity</span>
        </p>
        <p className="mt-2 text-sm uppercase tracking-[0.2em] text-white/50">Administration</p>

        <form onSubmit={submit} className="mt-12 space-y-8" data-testid="admin-login-form">
          <input data-testid="login-email" type="email" required placeholder="Adresse e-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="login-password" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-none bg-brand-gold py-4 text-xs uppercase tracking-[0.15em] text-brand-green transition-colors hover:bg-white disabled:opacity-50">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <div className="my-8 flex items-center gap-4 text-white/30">
          <span className="h-px flex-1 bg-white/15" />
          <span className="text-xs uppercase tracking-widest">ou</span>
          <span className="h-px flex-1 bg-white/15" />
        </div>

        <button data-testid="login-google" onClick={googleLogin} className="w-full rounded-none border border-white/25 py-4 text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-white hover:text-brand-green">
          Continuer avec Google
        </button>
      </div>
    </div>
  );
}
